import request from '@/api/request'

// 科目列表
export const getBktSubjectListPage = (params) => {
    return request({
        url: 'acm/adm/bktSubject/getListPage',
        method: 'get',
        params
    })
}

// 添加科目
export const addBktSubject = (data) => {
    return request({
        url: 'acm/adm/bktSubject/addBktSubject',
        method: 'post',
        data
    })
}

// 修改科目
export const updateBktSubject = (data) => {
    return request({
        url: 'acm/adm/bktSubject/updateBktSubject',
        method: 'post',
        data
    })
}

// 删除科目
export const delBktSubject = (data) => {
    return request({
        url: 'acm/adm/bktSubject/delBktSubject',
        method: 'post',
        data
    })
}

// 修改科目状态
export const updateStatus = (data) => {
    return request({
        url: 'acm/adm/bktSubject/updateStatus',
        method: 'post',
        data
    })
}

// 修改科目序号
export const updateSortNum = (data) => {
    return request({
        url: 'acm/adm/bktSubject/updateSortNum',
        method: 'post',
        data
    })
}